<template>
  <div class="list-page">
    <crumbs title="账号管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="6">
          <el-select
            v-model="queryCondition.status"
            placeholder="启用状态"
            :clearable="true"
            style="width: 100%"
          >
            <el-option label="启用中" :value="1"> </el-option>
            <el-option label="已停用" :value="0"> </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <enumerate
            url="/api/adminrole/getroleidname"
            v-model="queryCondition.adminRoleId"
            placeholder="角色"
          />
        </el-col>
        <el-col :span="6">
          <enumerate
            url="/api/department/getdepartmentidname"
            v-model="queryCondition.departmentId"
            placeholder="部门"
          />
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="queryCondition.publishDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-input
            v-model="queryCondition.account"
            clearable
            placeholder="账号名称"
          >
          </el-input>
        </el-col>
        <el-col :span="11">
          <el-input
            v-model="queryCondition.userName"
            clearable
            placeholder="姓名"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar">
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        @click="redirectByPath(`/admin/privilegeManage/accountInfo/addition`)"
        >添加
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="selection" width="40"> </el-table-column>
        <el-table-column
          prop="account"
          label="账号名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          label="姓名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="departmentName"
          label="部门"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="adminRoleName"
          label="角色名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="操作" width="320" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="handleReset(scope.row)"
              >重置密码</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
    <reset-account-pwd
      v-if="resetDialog"
      :infoId="infoId"
      @close="resetDialog = false"
      @complete="completeReset"
    />
  </div>
</template>

<script>
export default {
  name: "accountList",
  data() {
    return {
      //查询条件`
      queryCondition: {
        status: "",
        adminRoleId: "",
        departmentId: "",
        publishDate: [],
        account: "",
        userName: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: [],
      // 重置密码弹框
      resetDialog: false,
      infoId: ""
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { publishDate, ...other } = this.queryCondition,
        mixin = {
          status: ""
        },
        [createStart = "", createEnd = ""] = publishDate || [];

      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        ...other,
        ...mixin,
        createStart,
        createEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("privilege", "getAccountList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/privilegeManage/accountInfo/modification`,
        {
          id
        },
        this.queryCondition
      );
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData([row.id]);
        })
        .catch(() => {});
    },
    loadDeleteData(idList) {
      this.$api("privilege", "batchAccountDelete", idList).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    },
    //重置密码
    handleReset(row) {
      const { id } = row;
      this.infoId = id;
      this.resetDialog = true;
    },
    // 完成添加项目
    completeReset() {
      this.resetDialog = false;
    }
  }
};
</script>

<style></style>
